<div class="filegrid">
  <div class="filegrid__dropzone">
    <swb-dropzone (fileUploaded)="uploaded($event)" *ngIf="field.upload"></swb-dropzone>
    <a class="cta cta--yellow filegrid__browse" (click)="browse()" *ngIf="field.upload">
      <span class="ico-doc"></span> &nbsp;Vybrat</a>
    <a class="cta cta--yellow cta--ico-left filegrid__browse" *ngIf="!field.upload" [routerLink]="{ outlets: { 'browse': ['entities', field.apiUrl, false ] } }">
      <span class="ico-doc"></span> Vybrat</a>
    <a class="cta cta--green cta--ico-left filegrid__browse" *ngIf="!field.upload && field.canCreate" [routerLink]="{ outlets: { 'modal-form': [field.apiUrl] } }">
      <span class="ico-plus"></span> Vytvořit</a>
  </div>
  <div>
  </div>
  <div class="filegrid__files" [dragula]="'contained-many'" [(dragulaModel)]="value">
    <div *ngFor="let item of value; let i=index;" class="filegrid__file__wrap">
      <div class="filegrid__file" [ngStyle]="getFileStyle(item)">
        <div class="filegrid__actions">
          <a [routerLink]="{ outlets: { 'modal': ['file', item.id] } }" class="filegrid__actions__action" *ngIf="item.is_image">
            <i class="ico-edit"></i>
          </a>
          <a (click)="remove(i)" class="filegrid__actions__action filegrid__actions__action--remove">
            <i class="ico-remove"></i>
          </a>
        </div>
        <div class="filegrid__filename" *ngIf="!item.is_image">{{ !item.file_fullname ? getTitle(item) : item.file_name
          | slice:0:40 }}</div>
        <div *ngIf="item.file_fullname" class="filegrid__file__filetype media__list__item__filetype--{{item.extension}}">{{item.extension}}</div>
      </div>
    </div>
  </div>
</div>